/*
 * kokiriyama — reference prices in the visitor's currency.
 * DISPLAY ONLY: the store sells and charges in JPY. Nothing here touches cart, checkout or Shopify currency.
 * Rates: ExchangeRate-API open endpoint (daily, attribution required), fallback: fawazahmed0 currency-api (jsDelivr).
 * Cached in localStorage for 12h; a stale cache (<72h) is used if both sources fail; otherwise everything stays hidden.
 */
(function () {
  'use strict';
  var STORE_KEY = 'kk_ref_rates_v1';
  var PREF_KEY = 'kk_ref_currency';
  var FRESH_MS = 12 * 3600 * 1000;
  var STALE_MS = 72 * 3600 * 1000;
  var SOURCES = [
    { url: 'https://open.er-api.com/v6/latest/JPY',
      parse: function (j) { return j && j.result === 'success' && j.rates ? j.rates : null; } },
    { url: 'https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/jpy.min.json',
      parse: function (j) {
        if (!j || !j.jpy) return null; var r = {};
        Object.keys(j.jpy).forEach(function (k) { if (/^[a-z]{3}$/.test(k)) r[k.toUpperCase()] = j.jpy[k]; });
        return r;
      } }
  ];

  // Currencies offered in the selector (order matters).
  var MENU = ['USD', 'EUR', 'GBP', 'CNY', 'TWD', 'HKD', 'KRW', 'THB', 'SGD', 'MYR', 'IDR', 'AUD', 'CAD', 'CHF'];
  // Explicit prefixes so CNY never shows as "¥" (confusable with JPY) and $ currencies are unambiguous.
  var PREFIX = { USD: 'US$', EUR: '€', GBP: '£', CNY: 'RMB ', TWD: 'NT$', HKD: 'HK$', MOP: 'MOP$', KRW: '₩', THB: '฿',
    SGD: 'S$', MYR: 'RM', IDR: 'Rp ', PHP: '₱', INR: '₹', VND: '₫', AUD: 'A$', NZD: 'NZ$', CAD: 'C$', CHF: 'CHF ',
    MXN: 'MX$', SEK: 'SEK ', NOK: 'NOK ', DKK: 'DKK ', PLN: 'PLN ', CZK: 'CZK ', HUF: 'HUF ', ILS: '₪', AED: 'AED ',
    SAR: 'SAR ', QAR: 'QAR ', UAH: '₴', CLP: 'CLP ', ARS: 'ARS ', KZT: 'KZT ', MNT: 'MNT ', LAK: 'LAK ', MMK: 'MMK ', NPR: 'NPR ' };
  var EUR_CC = 'AT BE CY DE EE ES FI FR GR HR IE IT LT LU LV MT NL PT SI SK VA'.split(' ');
  var COUNTRY = { US: 'USD', UM: 'USD', CN: 'CNY', TW: 'TWD', HK: 'HKD', MO: 'HKD', KR: 'KRW', TH: 'THB', SG: 'SGD',
    MY: 'MYR', ID: 'IDR', PH: 'PHP', IN: 'INR', VN: 'VND', GB: 'GBP', CH: 'CHF', AU: 'AUD', NZ: 'NZD', CA: 'CAD',
    MX: 'MXN', SE: 'SEK', NO: 'NOK', DK: 'DKK', PL: 'PLN', CZ: 'CZK', HU: 'HUF', IL: 'ILS', AE: 'AED', SA: 'SAR',
    QA: 'QAR', UA: 'UAH', CL: 'CLP', AR: 'ARS', KZ: 'KZT', MN: 'MNT', LA: 'LAK', MM: 'MMK', NP: 'NPR', JP: null };
  EUR_CC.forEach(function (c) { COUNTRY[c] = 'EUR'; });

  var locale = (document.documentElement.lang || 'ja').toLowerCase(); // 'ja' | 'en' | 'zh-tw'
  var isZh = locale.indexOf('zh') === 0, isJa = locale.indexOf('ja') === 0;
  var country = (window.Shopify && window.Shopify.country) || document.documentElement.getAttribute('data-country') || '';
  // Shopify reports JP for visitors whose geo-IP country is in no market (and for anyone browsing from Japan).
  // For non-Japanese pages in that case, fall back to the region of the browser's languages (ko-KR -> KR, en-GB -> GB),
  // or to the language itself when it has no region (ko -> KR, th -> TH). Real geo-IP countries other than JP still win.
  var LANG_CC = { ko: 'KR', th: 'TH', id: 'ID', ms: 'MY', vi: 'VN', de: 'DE', fr: 'FR', it: 'IT', es: 'ES', nl: 'NL', pt: 'PT',
    fi: 'FI', el: 'GR', sk: 'SK', sv: 'SE', da: 'DK', nb: 'NO', no: 'NO', pl: 'PL', cs: 'CZ', hu: 'HU', he: 'IL', uk: 'UA', kk: 'KZ', mn: 'MN' };
  function browserCountry() {
    var langs = (navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || '']);
    for (var i = 0; i < langs.length; i++) {
      var parts = String(langs[i]).split(/[-_]/), lang = parts[0].toLowerCase();
      if (lang === 'ja') return '';
      for (var j = 1; j < parts.length; j++) {
        var rg = parts[j].toUpperCase();
        if (/^[A-Z]{2}$/.test(rg) && rg !== 'JP' && Object.prototype.hasOwnProperty.call(COUNTRY, rg)) return rg;
      }
      if (lang === 'zh') { var s = String(langs[i]).toLowerCase(); if (/hans|-cn|-sg/.test(s)) return 'CN'; if (/-hk|-mo/.test(s)) return 'HK'; }
      if (LANG_CC[lang]) return LANG_CC[lang];
    }
    return '';
  }

  function defaultCurrency() {
    // JP is also Shopify's fallback for countries outside every market (e.g. BR), so for JP only the ja locale means "off".
    if ((country === 'JP' || !country) && !isJa) { var bc = browserCountry(); if (bc && COUNTRY[bc]) return COUNTRY[bc]; }
    if (country === 'JP') return isJa ? null : (isZh ? 'TWD' : 'USD');
    if (Object.prototype.hasOwnProperty.call(COUNTRY, country)) return COUNTRY[country];
    if (isJa) return null;
    if (isZh) return 'TWD';
    return 'USD';
  }
  function chosenCurrency() {
    try { var p = localStorage.getItem(PREF_KEY); if (p === 'OFF') return null; if (p) return p; } catch (e) {}
    return defaultCurrency();
  }

  function readCache() {
    try { var c = JSON.parse(localStorage.getItem(STORE_KEY) || 'null'); if (c && c.rates && c.ts) return c; } catch (e) {}
    return null;
  }
  function fetchJSON(url) {
    var ctl = window.AbortController ? new AbortController() : null;
    var t = setTimeout(function () { if (ctl) ctl.abort(); }, 5000);
    return fetch(url, { signal: ctl ? ctl.signal : undefined, credentials: 'omit' })
      .then(function (r) { clearTimeout(t); if (!r.ok) throw new Error(r.status); return r.json(); });
  }
  function loadRates() {
    var cache = readCache();
    if (cache && Date.now() - cache.ts < FRESH_MS) return Promise.resolve(cache.rates);
    var i = 0;
    function next() {
      if (i >= SOURCES.length) {
        return (cache && Date.now() - cache.ts < STALE_MS) ? cache.rates : null;
      }
      var s = SOURCES[i++];
      return fetchJSON(s.url).then(function (j) {
        var r = s.parse(j);
        if (!r || !(r.USD > 0)) throw new Error('bad rates');
        try { localStorage.setItem(STORE_KEY, JSON.stringify({ ts: Date.now(), rates: r })); } catch (e) {}
        return r;
      }).catch(next);
    }
    return next();
  }

  function fmt(yen, cur, rate) {
    var v = yen * rate;
    if (!isFinite(v) || v <= 0) return '';
    var digits = v < 10 ? 2 : 0;
    var num = new Intl.NumberFormat('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(v);
    return (PREFIX[cur] || cur + ' ') + num;
  }
  function label(text, from) {
    if (isJa) return '≈ ' + text + (from ? '〜' : '') + '（参考）';
    if (isZh) return '≈ ' + text + (from ? ' 起' : '') + '（參考）';
    return (from ? 'from ≈ ' : '≈ ') + text + ' (est.)';
  }

  var RATES = null;
  function render() {
    var cur = chosenCurrency();
    var rate = cur && RATES ? RATES[cur] : null;
    var on = !!(rate > 0);
    var key = on ? cur + ':' + rate : 'off';
    document.querySelectorAll('[data-ref-jpy]').forEach(function (el) {
      if (el.getAttribute('data-ref-done') === key) return; // avoid MutationObserver loops
      el.setAttribute('data-ref-done', key);
      var yen = parseInt(el.getAttribute('data-ref-jpy'), 10);
      var txt = on && yen > 0 ? fmt(yen, cur, rate) : '';
      if (txt) { el.textContent = label(txt, el.hasAttribute('data-ref-from')); el.hidden = false; }
      else { el.textContent = ''; el.hidden = true; }
    });
    document.querySelectorAll('[data-ref-note]').forEach(function (note) {
      var sel = note.querySelector('[data-ref-select]');
      if (sel && !sel.options.length) buildSelect(sel);
      if (sel) sel.value = cur && RATES && RATES[cur] ? cur : 'OFF';
      // Japanese visitors in Japan with nothing selected: hide the whole note. Otherwise show it (incl. selector).
      note.hidden = !RATES || (!on && isJa && defaultCurrency() === null && !hasPref());
    });
  }
  function hasPref() { try { return !!localStorage.getItem(PREF_KEY); } catch (e) { return false; } }
  function buildSelect(sel) {
    var list = MENU.slice(); var d = defaultCurrency();
    if (d && list.indexOf(d) < 0) list.unshift(d);
    var off = document.createElement('option'); off.value = 'OFF'; off.textContent = sel.getAttribute('data-off-label') || 'Off';
    sel.appendChild(off);
    list.forEach(function (c) {
      if (!RATES || !(RATES[c] > 0)) return;
      var o = document.createElement('option'); o.value = c; o.textContent = c; sel.appendChild(o);
    });
    sel.addEventListener('change', function () {
      try { localStorage.setItem(PREF_KEY, sel.value); } catch (e) {}
      render();
    });
  }

  var timer = null;
  function schedule() { clearTimeout(timer); timer = setTimeout(render, 80); }

  function start() {
    loadRates().then(function (r) {
      RATES = r;
      if (!RATES) return; // fallback: keep everything hidden
      render();
      // Variant change, cart drawer refresh, facets & infinite scroll re-render price HTML: re-apply.
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
